var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page auth-wrap"},[_c('div',{staticClass:"auth-head"},[_c('div',{staticClass:"auth-head__logo"},[_c('router-link',{attrs:{"to":_vm.$store.getters.GET_PATHS.login}},[_c('img',{attrs:{"src":"/img/login-group/login-logo.png","alt":"alt"}})])],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }